"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleFormValidator_1 = require("../ArticleFormValidator");
class VerpackungFormValidator {
    static gewicht(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.WeightUnits.kg;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.WeightUnits.lb;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static breite(options) {
        return VerpackungFormValidator.getDefaultLengthValidator(options);
    }
    static laenge(options) {
        return VerpackungFormValidator.getDefaultLengthValidator(options);
    }
    static kerndurchmesser(options) {
        return VerpackungFormValidator.getDefaultLengthValidator(options);
    }
    static flanschdurchmesser(options) {
        return VerpackungFormValidator.getDefaultLengthValidator(options);
    }
    static flanschstaerke(options) {
        return VerpackungFormValidator.getDefaultLengthValidator(options);
    }
    static trommelbelastungMax(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.WeightUnits.kg;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.WeightUnits.lb;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
    static verpackungPrice(options) {
        return echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
    }
    static konfektionierungPrice(options) {
        return echain_shared_form_validation_1.numberValidatorCreator.createGreaterValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
    }
    static count(options) {
        return ArticleFormValidator_1.ArticleFormValidator.anzahl(options);
    }
    static getDefaultLengthValidator(options) {
        const metricValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const metricUnit = echain_shared_quantities_1.LengthUnits.mm;
        const imperialValidator = echain_shared_form_validation_1.numberValidatorCreator.createGreaterEqualValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 2,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            threshold: 0,
        });
        const imperialUnit = echain_shared_quantities_1.LengthUnits.inch;
        return echain_shared_form_validation_1.quantityValidatorCreator.createQuantityThresholdValidator({
            unitSystem: options.unitSystem,
            metricValidator,
            metricUnit,
            imperialValidator,
            imperialUnit,
        });
    }
}
exports.VerpackungFormValidator = VerpackungFormValidator;
//# sourceMappingURL=VerpackungFormValidator.js.map